/**
 * @date: 12/3/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {useState, useEffect} from 'react';
import {TableContainer} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {getDateFromString, getDaysToExpire, printDateHtml, printStatusHtml} from "../utils/cert-helper";
import Button from "@mui/material/Button";
import KeyValuePair from "../utils/components/KeyValuePair";
import makeStyles from '@mui/styles/makeStyles';
import AddIcon from '@mui/icons-material/Add';
import MaxMDLabel from "../utils/components/MaxMDLabel";
const useStyles = makeStyles((theme) => ({
    backButton: {
        marginRight: 20,
        // marginLeft: -120
    },

    orgName  : {
        color: '#444', fontSize: 17, lineHeight: '25px'
    },
    notReportable: {
        marginLeft: 5, color: 'rgba(60,120,185,1)', fontSize: 14, fontWeight: 'bold'
    },
    userList: {
        listStyle: 'none', padding: 0
    },
    moduleWrapper: {
        marginBottom: 3
    }
}));
export default function ShowOrganizationsAsLink(props) {
    const classes = useStyles();
    const {organizations} = props;
    const account = props.account;
    const size = props.size || 'large'; // xlarge, large, small

    return (
        <div>
            { organizations && organizations.length > 0 && <TableContainer className='orgs-list-wrapper'>
                <Table>
                    <TableHead>
                        <TableRow>
                            {size === 'xlarge' && <>
                                <TableCell>Name</TableCell>
                                <TableCell>Address</TableCell>
                                {/*<TableCell>Sponsors</TableCell>*/}
                            </>}
                            {size === 'large' && <>
                                <TableCell>Name/Address</TableCell>
                                {/*<TableCell>Sponsors</TableCell>*/}
                            </> }
                            {size === 'small' && <>
                                <TableCell>Name/Address</TableCell>
                            </> }

                            <TableCell width={200}>Modules</TableCell>
                            <TableCell>Created</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {organizations.map((o) => {
                            const createdTs = o.createdTs ? getDateFromString(o.createdTs) : null;
                            const createdTsHtml = createdTs ? printDateHtml(createdTs) : "";
                            // var userEmails = o.userEmails && o.userEmails.split("|") || [];
                            // var userListHtml = (<ul className={classes.userList}>
                            //     {userEmails.map( (email, index) => {
                            //         if (email === ""){
                            //             return "";
                            //         } else {
                            //             return <li key={`org-${o.id}-useremail-${index}`}>{email}</li>
                            //         }
                            //     })}
                            // </ul>);

                            const orgAddressHtml = (<address>
                                {o.street1}
                                {o.street2 && <>, {o.street2} </>}
                                , {o.city}
                                , {`${o.state} ${o.zip5}`}
                            </address>);
                            return (
                                <TableRow key={o.id}>
                                    {size === 'xlarge' && <>
                                        <TableCell><div className={classes.orgName}>{o.name}  </div></TableCell>
                                        <TableCell>{orgAddressHtml}</TableCell>
                                        {/*<TableCell>{userListHtml}</TableCell>*/}
                                    </>}
                                    {size === 'large' && <>
                                        <TableCell>
                                            <div className={classes.orgName}>{o.name}

                                            </div>
                                            {orgAddressHtml}
                                            {/*<KeyValuePair name='Address' renderValue={() => orgAddressHtml} />*/}
                                        </TableCell>
                                        {/*<TableCell>{userListHtml}</TableCell>*/}
                                    </> }
                                    {size === 'small' && <>
                                        <TableCell>
                                            <div className={classes.orgName}>{o.name} </div>
                                            {orgAddressHtml}
                                            <br/>
                                            {/*<KeyValuePair name='Address' renderValue={() => orgAddressHtml} />*/}
                                            {/*<KeyValuePair name='Sponsors' renderValue={() => userListHtml } />*/}
                                        </TableCell>
                                    </> }
                                    <TableCell >
                                        <div className={classes.moduleWrapper}>
                                            {o.notificationModule ? <MaxMDLabel full={true} color='info' value='Receive Notification' /> : <MaxMDLabel full={true} value='Receive Notification' /> }
                                        </div>
                                        <div className={classes.moduleWrapper}>
                                            {o.sendNotificationModule ? <MaxMDLabel full={true} color='info' value='Send Notification' /> : <MaxMDLabel full={true} value='Send Notification' /> }
                                        </div>
                                        <div className={classes.moduleWrapper}>
                                            {o.referralModule ? <MaxMDLabel full={true} color='info' value='Referral' /> : <MaxMDLabel full={true} value='Referral' /> }
                                        </div>
                                        <div className={classes.moduleWrapper}>
                                            {o.messageModule ? <MaxMDLabel full={true} color='info' value='Messaging' /> : <MaxMDLabel full={true} value='Messaging' /> }
                                        </div>
                                    </TableCell>
                                    <TableCell >
                                        {createdTsHtml}
                                    </TableCell>
                                    <TableCell >
                                        {account.organization && account.organization.id === o.id && <MaxMDLabel color='succ' value='Selected' />}
                                        {!(account.organization && account.organization.id === o.id) && <div>
                                            <Button className={classes.backButton} value='text' color='primary' onClick={() => props.handleSelectOrgForm(o, account)} > Enter </Button> <br/>
                                        </div>}

                                    </TableCell>
                                </TableRow>
                            )

                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            }
        </div>
    );
}
